import downloadCenter from '@/utils/downloadCenter'

export default {
  computed: {
    paperDownloadTasks: {
      get() {
        return downloadCenter.state.tasks
      },
      set(value) {
        downloadCenter.state.tasks = Array.isArray(value) ? value : []
      }
    },
    paperDownloadListVisible: {
      get() {
        return downloadCenter.state.visible
      },
      set(value) {
        downloadCenter.state.visible = !!value
      }
    },
    paperDownloadPanelCollapsed: {
      get() {
        return downloadCenter.state.collapsed
      },
      set(value) {
        downloadCenter.state.collapsed = !!value
      }
    }
  },
  methods: {
    $canStartDownloadBatch(selectionCount, taskCount = selectionCount) {
      const result = downloadCenter.validateStart(selectionCount, taskCount)
      if (!result.ok && this.$message && typeof this.$message.warning == 'function') {
        this.$message.warning(result.message)
      }
      return result.ok
    },
    $hasRunningDownloadTasks() {
      return this.paperDownloadTasks.some(task => task && task.state == 'running')
    },
    $enqueuePaperDownloadTask(task, runner) {
      if (!this.$canStartDownloadBatch(1, 1)) {
        return false
      }
      downloadCenter.addTask(task, {
        retry: () => {
          if (typeof runner == 'function') {
            runner()
          }
        },
        revoke: item => {
          if (typeof this.revokePaperDownloadTaskUrl == 'function') {
            this.revokePaperDownloadTaskUrl(item)
          } else {
            downloadCenter.revokeTaskUrl(item)
          }
        }
      })
      if (typeof runner == 'function') {
        runner()
      }
      return true
    }
  }
}
